const statusGroup = [
    { codigo: 2, nome: 'Arquivo enviado', cor: '#5B5B5F' },
    { codigo: 3, nome: 'Arquivo recusado', cor: '#EC130F' },
];

const statusDetail = [
    { codigo: 0, nome: 'Pendente de Processamento', grupo: 2 },
    { codigo: 1, nome: 'Arquivo Rejeitado', grupo: 3 },
    { codigo: 2, nome: 'Arquivo Validado', grupo: 2 },
    { codigo: 3, nome: 'Arquivo Processado com Erro', grupo: 3 },
    { codigo: 4, nome: 'Arquivo Processado com Sucesso', grupo: 2 },
    { codigo: 5, nome: 'Arquivo em Processamento', grupo: 2 },
    { codigo: 6, nome: 'Arquivo de Retorno Processado', grupo: 2 },
    { codigo: 7, nome: 'Arquivo Pendente com Erro', grupo: 3 },
];

const typeFile = [
    { codigo: 'C', nome: 'Por contrato' },
    { codigo: 'G', nome: 'Por grupo de contrato' },
];

const exportStatus = { statusDetail, statusGroup, typeFile };

export default exportStatus;
